// extracted by mini-css-extract-plugin
export var center = "_68-2";
export var clickableRow = "_68-5";
export var expandedRow = "_68-7";
export var hoverable = "_68-4";
export var left = "_68-1";
export var right = "_68-3";
export var row = "_68-0";
export var selectedRow = "_68-6";
export var summaryRow = "_68-8";